<template>
  <div class="sign">
    <div class="sign-search">
      <div class="btn-box">
        <van-field
          size="small"
          v-model="search.key"
          placeholder="请扫码SKU/输入临柜号"
          clearable
          clear-trigger="always"
          right-icon="scan"
          @click-right-icon="scanSku"
          :formatter="relationNumberFmt"
          @keyup.13="getList()"
          @input="getList"
          @keyup="inputNum"
          ref="scanInp"
        />
        <van-field
          border
          clickable
          readonly
          size="small"
          placeholder="请选择"
          @click="toShowPicker"
          v-model="actionsSeleted"
          is-link
          arrow-direction="down"
          clearable
          clear-trigger="always"
        />
      </div>
      <div class="toSearch-box">
        <button class="sign-toSearch" @click="getList()">查询</button>
      </div>
    </div>

    <div class="sign-item">
      <ul class="bale-container">
        <li>
          <div v-if="isShowLabelingControl" style="flex: 0.75"></div>
          <div>货柜号</div>
          <div>预计发货日期</div>
          <div>箱数</div>
          <div>状态</div>
        </li>
        <template v-if="startSearch">
          <van-loading size="24px" vertical>加载中...</van-loading>
        </template>
        <template v-else>
          <template v-if="list.length">
            <li
              v-for="(item, index) in list"
              :key="index"
              style="position: relative"
            >
              <van-swipe-cell>
                <div style="display: flex">
                  <div v-if="isShowLabelingControl" class="check-box">
                    <van-checkbox
                      v-model="item.checked"
                      shape="square"
                      style="justify-content: center"
                      :disabled="![3, 4].includes(item.boxMarkType)"
                    ></van-checkbox>
                  </div>
                  <div class="swipe-div" @click="toDetail(item)">
	     <div>{{ item.containerNo }}({{item.jpContainerNo}})</div>
                    <div>{{ item.deliveryDate }}</div>
                    <div>{{ item.boxCount }}</div>
                    <div>{{ item.boxMarkTypeText }}</div>
                    <p
                      class="red"
                      style="position: absolute; top: 3px"
                      v-if="item.remark"
                    >
                      {{ item.remark | boxCodelenLimit }}
                    </p>
                  </div>
                </div>
                <template #right>
                  <van-button
                    square
                    type="danger"
                    style="height: 100%; top: -1px"
                    :style="{
                      'background-color': [3, 4].includes(item.boxMarkType)
                        ? '#35495e'
                        : '#ccc',
                      'border-color': [3, 4].includes(item.boxMarkType)
                        ? '#35495e'
                        : '#ccc',
                    }"
                    text="打印"
                    @click="
                      [3, 4].includes(item.boxMarkType) ? toPrint(item, 0) : ''
                    "
                  />
                </template>
              </van-swipe-cell>
            </li>
          </template>
          <template v-else>
            <van-empty image="search" description="暂无数据" />
          </template>
        </template>
      </ul>

      <div class="submit-box">
        <div v-show="isShowLabelingControl">
          <van-row type="flex" justify="center" align="center">
            <van-col span="8" class="noSend-list-left"
              ><van-checkbox
                v-model="allCheckedCode"
                :disabled="!list.length"
                shape="square"
                >全选</van-checkbox
              ></van-col
            >
            <van-col
              span="16"
              class="noSend-list-right"
              @click="toPrint(null, 1)"
              >打印箱唛</van-col
            >
          </van-row>
        </div>
      </div>
    </div>

    <van-action-sheet
      v-model="showPicker"
      :actions="actions"
      closeable
      :lazy-render="false"
      cancel-text="确认选择"
      description="请选择"
      @select="actionSheetSelect"
      @cancel="actionSheetCancel"
    />

    <van-action-sheet
      v-model="showActionSheetForPrint"
      :actions="actionsForPrint"
      closeable
      :lazy-render="false"
      cancel-text="取消"
      description="请先选择打印机"
      @select="actionSheetSelectForPrint"
    />

    <van-dialog
      title=" "
      v-model="show"
      :show-cancel-button="true"
      confirmButtonText="打印"
      cancelButtonText="取消"
      :before-close="confirm"
    >
      <el-form
        :model="addForm"
        ref="addRuleForm"
        auto-complete="off"
        style="overflow-x: hidden; overflow-y: hidden; margin-left: 3%"
      >
        <el-row>
          <el-col :span="15">
            <el-col :span="8">
              <el-form-item
                label=""
                style="text-align: right; padding-right: 18%"
              >
                <span>份数</span>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="">
                <el-input
                  auto-complete="off"
                  min="1"
                  type="number"
                  style="width: 100px"
                  v-model="addForm.printNumber"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="9">
            <el-form-item label="">
              <el-radio :label="1" v-model="addForm.barCodeRadio"
                >所有页面</el-radio
              >
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="15">
            <el-col :span="8">
              <el-form-item label="">
                <el-radio :label="2" v-model="addForm.barCodeRadio"
                  >页面</el-radio
                >
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="">
                <el-input
                  auto-complete="off"
                  style="width: 100px"
                  :disabled="addForm.barCodeRadio == 1 ? true : false"
                  v-model="addForm.printPage"
                  type="text"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col :span="9">
            <el-form-item label="范例:">
              <span> 1,5-9,12</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :hidden="
            addForm.barCodeRadio == 2 || printList.length > 1 ? false : true
          "
        >
          <el-col :span="23">
            <el-form-item label="">
              <el-input
                v-model="addForm.printText"
                auto-complete="off"
                type="text"
                @click.native="locationFocus"
                placeholder="请选择打印文件"
                suffix-icon="el-icon-arrow-down"
                readonly="readonly"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <input type="hidden" v-model="addForm.pageCount" />
        <input type="hidden" v-model="addForm.printUrl" />
        <input type="hidden" v-model="addForm.stockingTaskID" />
      </el-form>
    </van-dialog>

    <!-- 调拨打印下拉 -->
    <van-popup
      v-model="printShowPicker"
      round
      position="bottom"
      get-container="#app"
    >
      <van-picker
        show-toolbar
        confirm-button-text="确认"
        cancel-button-text="取消"
        :columns="printList"
        @cancel="printShowPicker = false"
        @confirm="onConfirmPrint"
        :item-height="30"
        :visible-item-count="5"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  ActionSheet,
  SwipeCell,
  Button,
  Col,
  Row,
  Dialog,
} from "vant";
import {
  getLabeling,
  UpdateStockingTaskBoxMarkType,
} from "@/api/mobile/labeling_api";
import { GetPrinterByUser, AddUserPrinter } from "@/api/mobile/common_api";
import { mapState, mapMutations } from "vuex";
import util from "util/date";
import { debounce, throttle } from "util/util";
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
      search: {
        key: "",
        warehouseId: "",
        boxMarkType: "",
      },
      list: [],
      startSearch: false,
      tabType: "sku",
      showPicker: false,
      actions: [
        { name: "待上传装箱", id: 20 },
        { name: "已同步", id: 30 },
        { name: "同步失败", id: 99 },
        { name: "待上传箱唛", id: 1 },
        { name: "部分上传箱唛", id: 2 },
        { name: "待打印箱唛", id: 3 },
        { name: "已打印箱唛", id: 4 },
      ],
      actionsSeleted: "",
      isShowLabelingControl: false,
      allCheckedCode: false,
      showActionSheetForPrint: false,
      actionsForPrint: [],
      isSetPrinter: false,
      printSuccess: false,
      savePrintArr: [],
      show: false,
      barCodeRadio: 1,
      printType: 0,
      printList: [],
      addForm: {
        printNumber: 1,
        barCodeRadio: 1,
        pageCount: 10,
        stockingTaskID: 0,
      },
      printShowPicker: false,
    };
  },

  filters: {
    boxCodelenLimit(data) {
      if (data && data.length > 30) {
        return `${data.substring(0, 30)}...箱号重复！`;
      }
      return `${data}箱号重复！`;
    },
  },

  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Col.name]: Col,
    [Row.name]: Row,
    [ActionSheet.name]: ActionSheet,
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
  },

  mixins: [mixins],

  created() {
    this.init();
  },

  computed: {
    ...mapState({
      warehouse: (state) => state.common.warehouse,
      showLabelingControl: (state) => state.common.showLabelingControl,
    }),
  },

  mounted() {
    this.handleActionSheetEle();
    this.forPC();
  },

  methods: {
    ...mapMutations({}),

    init() {
      const _warehouse = window.localStorage.warehouse
        ? JSON.parse(window.localStorage.warehouse)
        : this.warehouse;
      this.$set(this.search, "warehouseId", _warehouse.warehouseId);

      this.toGetPrinterByUser();
      this.getList();
    },

    scanSku() {
      let that = this;
      this.$wx.scanQRCode({
        needResult: 1,
        desc: "scanQRCode desc",
        success: function (a) {
          that.$set(that.search, "key", a.resultStr);
          that.getList();
        },
      });
    },

    getList() {
      console.log("运输方式:" + this.$route.query.transportType);

      this.search.transportType =this.$route.query.transportType;

      const data = {
        ...this.search,
      };

      this.startSearch = true;

      getLabeling(data).then((res) => {
        this.startSearch = false;
        if (res.status === 200) {
          const { response } = res;

          if (!response.length) Toast("暂无匹配数据");

          this.list = response;
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    toDetail(item) {
      const { stockingTaskID, boxMarkType } = item;
      // if(boxMarkType != 4) return Toast('已打印箱唛才允许备柜，请左滑点击打印');

      if ([20, 30, 99].includes(boxMarkType))
        return Toast("请先前往电脑端上传装箱信息");
      this.$router.push({
        path: "/mobile/labelingList",
        query: { stockingTaskID },
      });
    },

    relationNumberFmt(v) {
      return v.trim();
    },

    // 处理ActionSheet 不显示关闭图标问题
    handleActionSheetEle() {
      document.getElementsByClassName(
        "van-action-sheet__description"
      )[0].innerHTML =
        '请选择<i class="van-icon van-icon-cross van-action-sheet__close" style="top:15px;"></i>';

      const closeEle = document.querySelector(
        "div.van-action-sheet__description > i"
      );
      const that = this;
      closeEle.addEventListener("click", function () {
        that.showPicker = false;
      });
    },

    toShowPicker() {
      this.showPicker = true;
      if (!this.actionsSeleted.length) {
        this.actions.forEach((item, i) => {
          this.$set(this.actions[i], "color", "");
        });
      }
    },

    actionSheetSelect(act, i) {
      if (this.actions[i].color) {
        this.$set(this.actions[i], "color", "");
        return;
      }
      this.$set(this.actions[i], "color", "#1989fa");
    },

    actionSheetCancel() {
      const arr = this.actions.filter((m) => {
        if (m.color) return m;
      });
      if (!arr.length) {
        this.actionsSeleted = "";
        this.search.boxMarkType = "";
        return;
      }

      let arr1 = [],
        n = [];
      arr.forEach((item) => {
        arr1.push(item.name);
        n.push(item.id);
      });
      this.actionsSeleted = arr1.toString();
      this.search.boxMarkType = n.toString();
    },

    actionSheetSelectForPrint(act, i) {
      this.toAddUserPrinter(act.id);
      this.showActionSheetForPrint = false;
    },

    jsonpPrint(url) {
      Toast.loading({
        message: "打印中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });

      this.$http
        .jsonp(url)
        .then((res) => {
          console.log("success", res.body.s); //请求成功
          Toast.clear();

          // 更新状态
          this.printSuccess = true;
        })
        .catch((err) => {
          console.log("err", err); //请求失败
          Toast.clear();
          if (err.status === 0) {
            // 更新状态    打印机有时会跑到err事件里,暂时这样处理
            this.printSuccess = true;
          } else {
            Toast.fail("打印失败");
          }
        });
    },

    // 打印
    toPrint(item, type) {
      if (!this.isSetPrinter) {
        Toast("请选择打印机");
        this.toGetPrinterByUser();
        return;
      }
      if (!this.list.length) {
        Toast("暂无数据");
        return;
      }

      this.printList = item.fileUrls;
      this.addForm.printNumber = 1;
      this.addForm.barCodeRadio = 1;
      this.$set(this.addForm, "printPage", "");
      this.$set(this.addForm, "printText", "");
      this.$set(this.addForm, "pageCount", 0);
      this.$set(this.addForm, "stockingTaskID", 0);
      this.$set(this.addForm, "printUrl", "");
      //this.addForm.printPage="";
      if (item.fileUrls.length == 1) {
        this.addForm.printText = item.fileUrls[0].text;
        this.addForm.pageCount = item.fileUrls[0].pageCount;
        this.addForm.stockingTaskID = item.fileUrls[0].stockingTaskID;
        this.addForm.printUrl = item.fileUrls[0].printUrl;
      }
      this.show = true;
      this.printSuccess = false;
    },

    //打印条码
    confirm(action, done) {
      if (action === "confirm") {
        let arr = [];
        const that = this;
        let item = this.printList;
        let radio = this.addForm.barCodeRadio;
        let regcarNumber = /^[1-9]\d*$/;
        if (this.addForm.printNumber === "") {
          Toast.fail("份数录入格式错误");
          return done(false);
        }
        if (!regcarNumber.test(this.addForm.printNumber)) {
          Toast.fail("请输入正整数");
          return done(false);
        }
        if (this.addForm.printNumber <= 0 || this.addForm.printNumber > 99) {
          Toast.fail("打印份数错误");
          return done(false);
        }
        if (
          this.addForm.stockingTaskID === "" ||
          this.addForm.stockingTaskID === 0
        ) {
          Toast.fail("请上传箱唛文件");
          return done(false);
        }
        if (radio === 1) {
          var dd =
            this.addForm.printUrl +
            "&printType=2&count=" +
            this.addForm.printNumber +
            "";
          var url = dd.replace("printType=1", "printType=2");
          that.jsonpPrint(url);
        } else {
          let printPage = this.addForm.printPage;
          if (printPage === "") {
            Toast.fail("页面不能为空");
            return done(false);
          }
          if (!regcarNumber.test(this.addForm.printPage)) {
            var pageList = new Array();
            if (printPage.indexOf(",") > -1) {
              pageList = printPage.split(",");
            } else {
              pageList.push(printPage);
            }
            for (let i = 0; i < pageList.length; i++) {
              if (pageList[i].indexOf("-") > -1) {
                let startStop = pageList[i].split("-");
                if (startStop.length != 2) {
                  Toast.fail("页面填写格式错误");
                  return done(false);
                } else {
                  let startPage = startStop[0];
                  let endPage = startStop[1];
                  if (
                    !regcarNumber.test(startPage) ||
                    !regcarNumber.test(endPage)
                  ) {
                    Toast.fail("请输入正整数");
                    return done(false);
                  }
                  if (startPage > endPage) {
                    Toast.fail("打印结束页面不能小于打印开始页面");
                    return done(false);
                  }
                  if (endPage > this.addForm.pageCount) {
                    Toast.fail("打印页面不能大于文件总页数");
                    return done(false);
                  }
                }
              } else {
                if (!regcarNumber.test(pageList[i])) {
                  Toast.fail("请输入正整数");
                  return done(false);
                } else {
                  if (pageList[i] > this.addForm.pageCount) {
                    Toast.fail("打印页面不能大于文件总页数");
                    return done(false);
                  }
                }
              }
            }
          } else {
            if (printPage > this.addForm.pageCount) {
              Toast.fail("打印页面不能大于文件总页数");
              return done(false);
            }
          }

          var rrr =
            this.addForm.printUrl +
            "&count=" +
            this.addForm.printNumber +
            "&pages=" +
            printPage +
            "";
          var url = rrr.replace("printType=1", "printType=2");
          console.log(url);
          that.jsonpPrint(url);
        }
        arr.push(this.addForm.stockingTaskID);
        this.$refs["addRuleForm"].resetFields();
        this.savePrintArr = arr;
        return done();
      } else {
        return done();
      }
    },

    //弹出调拨文件选择
    locationFocus() {
      this.printShowPicker = true;
    },
    //选择调拨文件
    onConfirmPrint(val) {
      this.$set(this.addForm, "printText", val.text);
      this.$set(this.addForm, "pageCount", val.pageCount);
      this.$set(this.addForm, "stockingTaskID", val.stockingTaskID);
      this.$set(this.addForm, "printUrl", val.printUrl);
      this.printShowPicker = false;
    },
    printBarCode() {
      const data = this.savePrintArr,
        that = this;
      UpdateStockingTaskBoxMarkType(data).then((res) => {
        if (res.status === 200 && res.success) {
          Toast.success(res.msg || "打印成功");
          setTimeout(() => {
            that.getList();
          }, 1500);
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    // 查询用户是否设置打印机
    toGetPrinterByUser() {
      const data = {
        moduleType: 2, // 打包 1 ，备柜 2
        wareId: this.search.warehouseId,
      };
      this.isSetPrinter = false;
      this.actionsForPrint = [];
      GetPrinterByUser(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200 && response.length) {
          this.showActionSheetForPrint = true;
          response.forEach((item, i) => {
            this.actionsForPrint.push({
              name: item.printerName,
              id: item.printerInfoID,
            });
          });
        } else if (status === -100) {
          Toast(msg);
        }
        if (status === 200 && response === 0) {
          this.isSetPrinter = true;
        }
      });
    },

    // 新增打印机
    toAddUserPrinter(id) {
      const data = {
        moduleType: 2, // 打包 1 ，备柜 2
        printerInfoID: id,
      };
      AddUserPrinter(data).then((res) => {
        const { status, response, msg } = res;
        if (status === 200) {
          this.isSetPrinter = true;
          Toast.success(msg || "添加打印机成功");
        } else {
          Toast(msg);
        }
      });
    },
  },

  watch: {
    $route: async function (newValue, from) {
      this.$nextTick(() => {});
    },
    showLabelingControl: {
      handler(n, o) {
        this.isShowLabelingControl = n;
      },
      immediate: true,
    },
    printSuccess: function (o, n) {
      if (o) {
        this.printBarCode(this.savePrintArr);
      }
    },
    allCheckedCode: function (o, n) {
      if (o) {
        this.list.forEach((item, i) => {
          if ([3, 4].includes(item.boxMarkType)) {
            this.$set(this.list[i], "checked", true);
          }
        });
      } else {
        this.list.forEach((item, i) => {
          if ([3, 4].includes(item.boxMarkType)) {
            this.$set(this.list[i], "checked", false);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.sign-search {
  justify-content: center;
  padding: 20px 20px 15px 20px;
}

.sign-search .toSearch-box {
  flex: 0.4;
  margin-left: 3%;
  min-height: 94px;
}

.sign-search .btn-box {
  flex: 0.8;
}

::v-deep .van-cell {
  padding: 7px 16px;
}

.sign-toSearch {
  width: 100%;
  height: 92%;
  min-height: 87px;
  border-radius: 5px;
  border: 0;
  color: #fff;
  font-size: 20px;
}

::v-deep .van-tabs__nav--card {
  margin: 0;
  border: 0;
}
::v-deep .van-action-sheet__item {
  line-height: 10px;
}
::v-deep .van-action-sheet__item,
.van-action-sheet__cancel {
  padding: 12px 16px;
}
.sign-item .bale-container {
  margin-bottom: 75px;
}

.sign-item .bale-container li {
  display: flex;
  height: 40px;
  line-height: 40px;
  & > div {
    flex: 1;
    text-align: center;
  }
}

.sign-item .bale-container li {
  padding: 0;
  height: 46px;
  line-height: 40px;
}

.sign-item .bale-container .swipe-div {
  display: flex;
  padding: 5px;
  align-items: center;
  flex: 1;
  & > div {
    flex: 1;
  }
}

.noSend-list-left {
  border-top: 1px solid #908d8d;
  border-bottom: 1px solid #908d8d;
  height: 40px;
  line-height: 40px;
  text-align: left;
  padding: 8px 0 0 32px;
  background-color: #fff;
}
.noSend-list-right {
  border-top: 1px solid #908d8d;
  border-bottom: 1px solid #908d8d;
  height: 40px;
  line-height: 40px;
  background-color: #35495e;
  color: #fff;
}

.check-box {
  flex: 0.2;
  display: flex;
  justify-content: center;
}
</style>